<template>
    <div class="file">
        <div class="file-top">{{title}}</div>
        <div class="file-body">
            <div class="file-body-top">
                <span class="top-text">共有{{ total }}个文件</span>
                <span class="top-checked" @click="checkedAll">全选</span>
            </div>
            <div class="file-body-count" v-for="(item, index) in dataList" :key="'list' + index">
                <div class="count-l">
                    <img class="count-l-img" :src="item.icon" alt="文件图标">
                    <div class="count-l-r">
                        <div class="r-title">{{item.fileName}}</div>
                        <div class="r-size">{{ borntime_deal(item.fileSize) }}</div>
                    </div>
                </div>
                <div class="count-r">
                    <van-checkbox v-model="item.checked"></van-checkbox>
                </div>
            </div>
        </div>
        <van-list
            v-model:loading="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            
        >
        <!-- @load="onLoad" -->
            <van-cell v-for="item in list" :key="item" :title="item" />
        </van-list>
        <van-button square type="primary" class="file-down" @click="downloadFileFun">立即下载</van-button>
    </div>
</template>

<script>
import { isWeChat } from '@/utils/validate';
import { getUrlKey } from '@/utils/util'
import axios from "axios";
import Client from '@/utils/client'
const getFile = url => {
    return new Promise((resolve, reject) => {
        axios({
            method: "get",
            url,
            responseType: 'blob',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        }).then(data => {
            resolve(data.data);
        }).catch(error => {
            reject(error.toString());
        });
    });
};
// import { getAliToken } from "@/utils/oss";
export default {
    // 资料库
    name: 'FileDownload',
    data() {
        return {
            checked: false,
            checked1: true,
            line: 20,
            rates: 20,
            shareInfo: {},
            loading: false,
            finished: false,
            page: 1,
            dataList: [],
            downloadList: [],
            sizeFn: this.renderSize,
            downList: [],
            title: '',
            client: null,
            total: 0
        }
    },
    created() {
        let isWe = isWeChat()
        if(isWe) {
            this.submitDelete()
        }
        if(!isWe) {
            this.getOssInfo()
        }
        // this.getDatabaseList()
    },
    methods: {
        checkedAll() {
            let arr = this.dataList
            arr.forEach(item => {
                item.checked = true
            })
            this.dataList = arr
            this.downList = this.dataList
        },
        submitDelete() {
            this.$dialog.confirm({
                message: '请点击页面右上角". . ."选择“在浏览器打开”',
                confirmButtonColor: "#0F50C5",
                cancelButtonColor: "#000000"
            });
        },
        // 获取oss配置参数
        getOssInfo() {
            this.$http.post('/h5/data/sts').then(({ data: res }) => {
                if(res.success) {
                    let oss = res.data
                    this.client = Client(oss)
                }else {
                    this.$toast.fail(res.errorMessage);
                }
            })
        },
        // 获取资料库下载列表  /data/list
        getDatabaseList() {
            this.loading = true
            this.$http.post('/h5/data/share',{
                size: 10, page: this.page,
                code: getUrlKey('code')
            }).then(({ data: res }) => {
                if(res.success) {
                    let pageVal = this.page
                    const _new = res.list || []
                    this.f_List(_new)
                    pageVal += 1
                    this.page = pageVal
                    this.loading = false;
                    this.total = res.total
                    if(res.list.length < 10) {
                        this.finished = true
                    }
                    this.title = res.title
                } else {
                    this.$toast.fail(res.errorMessage);
                }
            })
        },
        f_List(list) {
            const resList = this.page == 1 ? [] : this.dataList
            let newList = []
            list.forEach(item => {
                item.sizes = this.borntime_deal(item.fileSize)
                item.checked = false
                newList.push(item)
            })
            resList.push(...newList)
            this.dataList = resList
            this.fileList = resList[0]
        },
        borntime_deal(filesize){
            if(!filesize){
                return "0 Bytes";
            }
            let unitArr = new Array("Bytes","KB","MB","GB","TB","PB","EB","ZB","YB");
            let index = 0;
            let srcsize = filesize
            index = Math.floor(Math.log( srcsize ) / Math.log(1024));
            let size = srcsize / Math.pow(1024, index);
            size = size.toFixed(2);//保留的小数位数
            return size + unitArr[index];
        },

        // 触底加载
        onLoad() {
            if(this.finished) {
                return
            }
            this.getDatabaseList()
        },
        downloadFileFun() {
            if(isWeChat()) {
                this.submitDelete()
                return
            }
            let arr = []
            this.dataList.forEach((item, index) => {
                if(item.checked) {
                    arr.push(index)
                    setTimeout(() => {
                        this.downloadFile(item)
                    }, index * 2000)
                }
            })
            if(0 == arr.length) {
                this.$toast.fail('请选择下载文件');
            }
            
        },
        async downloadFile(row) {
            let name = row.fileName
            const start = 0
            const path = this.getFileName(row.filePath);
            
            let url = this.client.signatureUrl(path, {
                response: {
                    'content-disposition': `attachment; filename=${name}`
                }
            });

            // saveAs(url, name)
            location.href = url;
        },
        getFileName(o) {
            let pos = o.lastIndexOf('.com')
            return o.substring(pos + 5) 
        }
    },
    computed:{
        
    }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>